import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLenis, scrollToId } from "@/components/site/useLenis";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { Approach } from "@/components/site/Approach";
import { Network } from "@/components/site/Network";
import { Sectors } from "@/components/site/Sectors";
import { Principles } from "@/components/site/Principles";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { CookieNotice } from "@/components/site/CookieNotice";

export default function Home() {
  useLenis();
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    const id = setTimeout(() => scrollToId(hash.slice(1)), 400);
    return () => clearTimeout(id);
  }, [hash]);

  return (
    <div className="grain min-h-screen bg-ink text-bone">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Approach />
        <Network />
        <Sectors />
        <Principles />
        <Contact />
      </main>
      <Footer />
      <CookieNotice />
    </div>
  );
}
